import { render, staticRenderFns } from "./DeviceProps.vue?vue&type=template&id=3d6ba974"
import script from "./DeviceProps.vue?vue&type=script&lang=ts"
export * from "./DeviceProps.vue?vue&type=script&lang=ts"
import style0 from "./DeviceProps.vue?vue&type=style&index=0&id=3d6ba974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports